import { createSessionStore } from 'stencil-store-storage';

const { state, onChange } = createSessionStore('onsitesearch-health', {
  shown: false,
  time: 0,
  lastSearchQuery: '',
});

onChange('shown', () => {
  // eslint-disable-next-line no-magic-numbers
  state.time = Date.now() / 1000;
});

export default state;
